import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Sun } from "lucide-react";
import { useContent } from "../lib/content";

const quickLinks = [
  { label: "Home", to: "/" },
  { label: "About Us", to: "/about" },
  { label: "Residential Solar", to: "/solutions/residential-solar" },
  { label: "Commercial Solar", to: "/solutions/commercial-solar" },
  { label: "Industrial Solar", to: "/solutions/industrial-solar" },
  { label: "Solar Pump", to: "/solutions/solar-pump-sets" },
  { label: "PM Surya Ghar", to: "/pm-surya-ghar" },
  { label: "Products", to: "/products" },
  { label: "Projects", to: "/projects" },
  { label: "FAQ", to: "/faq" },
  { label: "Contact", to: "/contact" },
];

const services = [
  { label: "Rooftop Solar", to: "/solutions/residential-solar" },
  { label: "On-Grid Solar", to: "/solutions/on-grid-solar" },
  { label: "Hybrid Solar", to: "/solutions/hybrid-solar" },
  { label: "Off-Grid Solar", to: "/solutions/off-grid-solar" },
  { label: "Solar Pump Sets", to: "/solutions/solar-pump-sets" },
  { label: "Commercial Solar", to: "/solutions/commercial-solar" },
  { label: "Industrial Solar", to: "/solutions/industrial-solar" },
  { label: "Solar Installation", to: "/process" },
  { label: "Solar Maintenance", to: "/contact" },
];

export const Footer = () => {
  const { SITE } = useContent();
  return (
  <footer className="bg-brand-navy text-white sun-rays relative" data-testid="footer">
    <div className="mx-auto max-w-7xl px-4 py-14 sm:px-6">
      <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-4">
        <div>
          <div className="flex items-center gap-2">
            <span className="flex h-10 w-10 items-center justify-center rounded-full bg-brand-orange">
              <Sun className="h-5 w-5 text-white" />
            </span>
            <div className="font-heading leading-tight">
              <p className="text-sm font-extrabold tracking-wide">DHIYAA</p>
              <p className="text-[11px] font-bold tracking-widest text-brand-orange">SOLAR ENERGY</p>
            </div>
          </div>
          <p className="mt-4 font-heading text-sm font-semibold text-brand-orange">{SITE.tagline}</p>
          <p className="mt-2 text-sm leading-relaxed text-white/60">
            Complete solar energy solutions for residential, commercial, industrial and agricultural applications.
          </p>
          <div className="mt-4 space-y-1 text-xs text-white/50">
            <p>GSTIN: {SITE.gstin}</p>
            <p>UDYAM: {SITE.udyam}</p>
          </div>
        </div>
        <div>
          <h4 className="font-heading text-sm font-bold uppercase tracking-widest text-brand-orange">Quick Links</h4>
          <ul className="mt-4 grid grid-cols-1 gap-2">
            {quickLinks.map((l) => (
              <li key={l.label}>
                <Link to={l.to} className="text-sm text-white/65 transition-colors hover:text-brand-orange" data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}>
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h4 className="font-heading text-sm font-bold uppercase tracking-widest text-brand-orange">Our Services</h4>
          <ul className="mt-4 grid grid-cols-1 gap-2">
            {services.map((l) => (
              <li key={l.label}>
                <Link to={l.to} className="text-sm text-white/65 transition-colors hover:text-brand-orange">
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h4 className="font-heading text-sm font-bold uppercase tracking-widest text-brand-orange">Contact</h4>
          <ul className="mt-4 space-y-3 text-sm text-white/65">
            <li>
              <a href={SITE.phone1} className="flex items-center gap-2.5 hover:text-brand-orange transition-colors" data-testid="footer-phone-1">
                <Phone className="h-4 w-4 shrink-0 text-brand-orange" /> {SITE.phone1Display}
              </a>
            </li>
            <li>
              <a href={SITE.phone2} className="flex items-center gap-2.5 hover:text-brand-orange transition-colors" data-testid="footer-phone-2">
                <Phone className="h-4 w-4 shrink-0 text-brand-orange" /> {SITE.phone2Display}
              </a>
            </li>
            <li>
              <a href={`mailto:${SITE.emails[0]}`} className="flex items-center gap-2.5 hover:text-brand-orange transition-colors break-all" data-testid="footer-email">
                <Mail className="h-4 w-4 shrink-0 text-brand-orange" /> {SITE.emails[0]}
              </a>
            </li>
            <li className="flex items-start gap-2.5">
              <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-brand-orange" />
              <span>{SITE.addressLines.join(", ")}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div className="border-t border-white/10">
      <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-3 px-4 py-5 text-xs text-white/50 sm:flex-row sm:px-6">
        <p>© 2026 DHIYAA SOLAR ENERGY. All Rights Reserved.</p>
        <div className="flex gap-5">
          <Link to="/privacy-policy" className="hover:text-brand-orange transition-colors" data-testid="footer-privacy">Privacy Policy</Link>
          <Link to="/terms" className="hover:text-brand-orange transition-colors" data-testid="footer-terms">Terms &amp; Conditions</Link>
          <Link to="/disclaimer" className="hover:text-brand-orange transition-colors" data-testid="footer-disclaimer">Disclaimer</Link>
        </div>
      </div>
    </div>
  </footer>
  );
};
